import { useMutation } from '@tanstack/react-query'

import { genreateDownloadReportCSV } from '../functions/genreateDownloadReportCSV'

export const useGenerateDownloadReportCSV = () => {
  return useMutation(genreateDownloadReportCSV)
}
